import { render, staticRenderFns } from "./all-projects.page.vue?vue&type=template&id=da472ae6&scoped=true&"
import script from "./all-projects.page.vue?vue&type=script&lang=js&"
export * from "./all-projects.page.vue?vue&type=script&lang=js&"
import style0 from "./all-projects.page.vue?vue&type=style&index=0&id=da472ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da472ae6",
  null
  
)

export default component.exports